var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agreement-wrapper"},[_c('Information',{attrs:{"name":"rightProtection"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }